import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import styles from './EmailVerifiedForm.module.scss';

const EmailVerifiedForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <p className={styles.title}>
        {t('emailVerification.emailVerified', 'Email vérifié avec succès !')}
      </p>
      <Button variant="filled" onClick={() => navigate('/auth')}>
        {t('emailVerification.signIn', 'Se connecter')}
      </Button>
    </div>
  );
};

export default EmailVerifiedForm;
